import { useMemo } from 'react';
import { OverlayTrigger, Popover, PopoverContent, PopoverTitle } from 'react-bootstrap';
import isoDateConverter from '../isoDateConverter';

const LoadStatusIcon = ({ status = {} }) => {
  const {
    Status: data,
    createdDate,
    errorDate,
    rosDate,
    ackDate,
    submitUser,
    refNumberUser,
    refTime,
    submitTime,
    refDepartment,
    submitDepartment,
    invVesselDep,
    invVesselTime,
    invVesselUser,
    remoteSystemUser,
    remoteSystemDep,
    remoteSystemTime,
    createdUser,
    createdRole,
    resubmissionDate,
    resubmissionUser,
    resubmissionDepartment,
    resubmissionDate1,
    resubmissionUser1,
    resubmissionDepartment1,
    overrideUser,
    overrideRole,
    overrideDate,
    createdFormUser,
    createdFormRole,
    amendedDate,
    amendedRole,
    amendedUser,
  } = status;

  const dates = useMemo(() => {
    return (
      <>
        {createdDate && (
          <p className="tooltip-text">
            {' '}
            <span className="cci-header">Submitted: </span>
            {isoDateConverter(createdDate)}
          </p>
        )}
        {ackDate && (
          <p className="tooltip-text">
            {' '}
            <span className="cci-header">In Progress: </span>
            {isoDateConverter(ackDate)}
          </p>
        )}
        {rosDate && (
          <p className="tooltip-text">
            {' '}
            <span className="cci-header">Completed: </span> {isoDateConverter(rosDate)}
          </p>
        )}
        {errorDate && (
          <p className="tooltip-text">
            <span className="cci-header">Failed: </span> {isoDateConverter(errorDate)}
          </p>
        )}
        {amendedDate && (
          <p className="tooltip-text">
            <span className="cci-header">Flagged for Amendment: </span> {amendedUser}, {amendedRole},{' '}
            {isoDateConverter(amendedDate)}
          </p>
        )}
      </>
    );
  }, [createdDate, errorDate, rosDate, ackDate, amendedDate]);

  return (
    <OverlayTrigger
      placement="top"
      trigger={['hover', 'focus']}
      overlay={
        <Popover style={{ minWidth: 0, maxWidth: 'none', width: 'auto' }}>
          <PopoverTitle>
            <h5 style={{ margin: 0 }}>Item Status</h5>
          </PopoverTitle>
          <PopoverContent>
            <div className="auditStatus">
              <span>
                <span className={`position-tips statusIcon ${data}`}></span>
              </span>
              <div className="statusTimeStamp">
                <span className="timeStampError">{data}</span>
                {dates}
                {(createdFormUser || createdUser) && (
                  <p className="tooltip-text">
                    <span className="cci-header">Created by: </span>
                    <span>
                      {createdFormUser ? createdFormUser : createdUser},{' '}
                      {createdFormRole ? createdFormRole : createdRole}, {isoDateConverter(createdDate)}
                    </span>
                  </p>
                )}
                {overrideUser && (
                  <p className="tooltip-text">
                    <span className="cci-header">Override: </span>
                    <span>
                      {overrideUser}, {overrideRole}, {isoDateConverter(overrideDate)}
                    </span>
                  </p>
                )}
                {submitUser && (
                  <p className="tooltip-text">
                    <span className="cci-header">Form submission: </span>
                    <span>
                      {submitUser}, {submitDepartment}, {isoDateConverter(submitTime)}
                    </span>
                  </p>
                )}

                {refNumberUser && (
                  <p className="tooltip-text">
                    <span className="cci-header">System reference entry: </span>
                    <span>
                      {refNumberUser}, {refDepartment}, {isoDateConverter(refTime)}
                    </span>
                  </p>
                )}

                {invVesselUser && (
                  <p className="tooltip-text">
                    <span className="cci-header">Vessel update: </span>
                    <span>
                      {invVesselUser}, {invVesselDep}, {isoDateConverter(invVesselTime)}
                    </span>
                  </p>
                )}
                {remoteSystemUser && (
                  <p className="tooltip-text">
                    <span className="cci-header">Customs software update: </span>
                    <span>
                      {remoteSystemUser}, {remoteSystemDep}, {isoDateConverter(remoteSystemTime)}
                    </span>
                  </p>
                )}
                {resubmissionDate && (
                  <p className="tooltip-text">
                    <span className="cci-header">Resubmission: </span>
                    <span>
                      {resubmissionUser}, {resubmissionDepartment}, {isoDateConverter(resubmissionDate)}
                    </span>
                  </p>
                )}
                {resubmissionDate1 && (
                  <p className="tooltip-text">
                    <span className="cci-header">Resubmission 1: </span>
                    <span>
                      {resubmissionUser1}, {resubmissionDepartment1}, {isoDateConverter(resubmissionDate1)}
                    </span>
                  </p>
                )}
              </div>
            </div>
          </PopoverContent>
        </Popover>
      }
    >
      <div className={`positions ${data}`}></div>
    </OverlayTrigger>
  );
};

export default LoadStatusIcon;
